import {useToast} from 'vue-toastification'
import {Modal} from 'bootstrap'
import useApi from "@/composables/useApi";

export default function useManpower() {
    const toast = useToast()
    const MODAL_ID = 'modalId'
    const {fetchResource, createResource, updateResource, deleteResource} = useApi()

    const baseStructure = {
        count: '', employment_hours: ''
    }

    const getModal = () => Modal.getOrCreateInstance(document.getElementById(MODAL_ID))

    const props = {
        subProcessId: {
            type: Number,
            required: true
        },
    }

    const data = () => ({
        items: [],
        apiUrl: '/v2/performance-management/effects-measurement/manpower',
        newItem: structuredClone(baseStructure),
        editedItem: null,
        editIndex: null,
        tableHeaders: ['تعداد', 'ساعت اشتغال'],
        tableFields: ['count', 'employment_hours'],
    })

    const methods = {
        validateItem(item) {
            if (!item.count || !item.employment_hours) {
                toast.error('همه فیلدها را کامل وارد کنید!')
                return false
            }
            return true
        },

        async fetchData() {
            const query = new URLSearchParams({sub_process_id: this.subProcessId}).toString()
            const response = await fetchResource(`${this.apiUrl}?${query}`)
            this.items = response.data
        },

        async addItem() {
            if (!this.validateItem(this.newItem)) return

            this.newItem['sub_process_id'] = this.subProcessId

            const response = await createResource(this.apiUrl, this.newItem)

            this.items.unshift(response.data)
            Object.assign(this.newItem, baseStructure)
        },

        async removeItem(index) {
            const deletedItem = this.items.find((_, i) => i === index);
            await deleteResource(`${this.apiUrl}/${deletedItem.id}`)
            this.items = this.items.filter((_, i) => i !== index)
        },

        async startEditing(item, index) {
            this.editedItem = structuredClone(item)
            this.editIndex = index
        },

        async editItem() {
            if (!this.validateItem(this.editedItem) || this.editIndex === null) throw new Error();

            const response = await updateResource(`${this.apiUrl}/${this.editedItem.id}`, this.editedItem)

            this.items.splice(this.editIndex, 1, response.data)
            this.editIndex = null
            this.editedItem = null
        },

        async openEditModal(item, index) {
            await this.startEditing(item, index)
            getModal().show()
        },

        async handleUpdate() {
            try {
                await this.editItem()
                getModal().hide()
            } catch (error) {
                console.log(error.message)
            }
        }
    }

    return {
        data, methods, props
    }
}
